// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"241":"428fc707","256":"5b549816","273":"5c102df0","871":"ebc22448","896":"785cb188"}[chunkId] + ".css";
};